// ============================================================================
// frontend/src/components/tenant/ThemePreview.tsx
// ============================================================================

import React from 'react';
import { TenantFormData } from '@/types/tenant';
import { THEME_PRESETS } from '@/constants/themes';

interface ThemePreviewProps {
  formData: TenantFormData;
  selectedTheme: string;
  customTheme: boolean;
}

export const ThemePreview: React.FC<ThemePreviewProps> = ({
  formData,
  selectedTheme,
  customTheme
}) => {
  return (
    <div className="rounded-lg border bg-card p-6 space-y-4">
      <h2 className="text-xl font-semibold border-b pb-3">👁️ Aperçu du thème</h2>
      
      {!customTheme && selectedTheme && (
        <div className="mb-4 p-3 bg-muted/30 rounded-lg flex items-center gap-3">
          <span className="text-2xl">
            {THEME_PRESETS.find(t => t.id === selectedTheme)?.icon}
          </span>
          <div>
            <p className="font-medium">
              {THEME_PRESETS.find(t => t.id === selectedTheme)?.name}
            </p>
            <p className="text-sm text-muted-foreground">
              {THEME_PRESETS.find(t => t.id === selectedTheme)?.description}
            </p>
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Light Preview */}
        <div 
          className="p-6 rounded-lg space-y-4"
          style={{
            backgroundColor: formData.secondary_color,
            borderRadius: `${formData.border_radius}rem`
          }}
        >
          <h3 className="font-semibold text-sm mb-2">Mode clair</h3>
          <button
            type="button"
            className="px-4 py-2 text-white font-medium"
            style={{
              backgroundColor: formData.primary_color,
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Bouton principal
          </button>
          <button
            type="button"
            className="px-4 py-2 font-medium"
            style={{
              backgroundColor: formData.accent_color,
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Bouton accent
          </button>
          <div 
            className="p-3 text-sm"
            style={{
              backgroundColor: 'white',
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Exemple de carte
          </div>
        </div>

        {/* Dark Preview */}
        <div 
          className="p-6 rounded-lg space-y-4"
          style={{
            backgroundColor: formData.dark_background_color,
            color: formData.dark_foreground_color,
            borderRadius: `${formData.border_radius}rem`
          }}
        >
          <h3 className="font-semibold text-sm mb-2">Mode sombre</h3>
          <button
            type="button"
            className="px-4 py-2 text-white font-medium"
            style={{
              backgroundColor: formData.dark_primary_color,
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Bouton principal
          </button>
          <button
            type="button"
            className="px-4 py-2"
            style={{
              backgroundColor: formData.dark_accent_color,
              color: formData.dark_foreground_color,
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Bouton accent
          </button>
          <div 
            className="p-3 text-sm"
            style={{
              backgroundColor: formData.dark_card_color,
              color: formData.dark_foreground_color,
              borderRadius: `${formData.border_radius}rem`
            }}
          >
            Exemple de carte
          </div>
        </div>
      </div>
    </div>
  );
};